import { useEffect, useState } from 'react';
import { Shield, Lock } from 'lucide-react';


export function LoadingSpinner() {
    const [dots, setDots] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => prev.length >= 3 ? '' : prev + '.');
        }, 500);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <div className="max-w-md w-full mx-4">
                <div className="bg-white rounded-lg shadow-lg p-8 border border-slate-200">
                    <div className="flex justify-center mb-6">
                        <div className="relative">
                            <div className="absolute inset-0 bg-blue-500 rounded-full opacity-20 animate-ping"></div>
                            <div className="relative bg-blue-500 p-4 rounded-full">
                                <Shield className="w-8 h-8 text-white" />
                            </div>
                        </div>
                    </div>

                    <h2 className="text-2xl font-semibold text-center text-slate-800 mb-2">
                        Verifying Authentication
                    </h2>

                    <p className="text-center text-slate-600 mb-1">
                        Please wait while we verify your session for
                    </p>
                    <p className="text-center text-slate-600 mb-6">
                        Rules Engine
                    </p>

                    <div className="flex items-center justify-center gap-2 text-sm text-slate-500 font-semibold">
                        <span>Secured by Workfinity</span>
                    </div>
                </div>

            </div>
        </div>
    );
}


export function RedirectingScreen() {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    window.location.href = 'https://bprm-ai-portal.workfinity.com/login';
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <div className="max-w-md w-full mx-4">
                <div className="bg-white rounded-lg shadow-lg p-8 border border-slate-200">
                    {/* Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="relative">
                            <div className="absolute inset-0 bg-amber-500 rounded-full opacity-20 animate-ping"></div>
                            <div className="relative bg-amber-500 p-4 rounded-full">
                                <Lock className="w-8 h-8 text-white" />
                            </div>
                        </div>
                    </div>

                    <h2 className="text-2xl font-semibold text-center text-slate-800 mb-2">
                        Authentication Failed
                    </h2>

                    <p className="text-center text-slate-600 mb-6">
                        Please Login first to Access Rules Engine
                    </p>

                    <div className="bg-slate-50 rounded-lg p-4 mb-6 border border-slate-200">
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-slate-600">Redirecting to Login Portal in</span>
                            <span className="text-lg font-semibold text-slate-800">{countdown}s</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}